// extracted by mini-css-extract-plugin
export default {"notification-toasts":"bf0a80"};